import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'

type Props = {
  heading: string
}

export const RecommendTrainingProgramHeading = ({
  heading,
}: Props): JSX.Element => (
  <div className="flex flex-row pb-[4.5vw] lg:pb-[0.8vw] lg:w-[24.6vw] border-b-[2px] border-[#F0B430]">
    <div className="lg:w-[2.3vw]">
      <ImageWraper
        src={`${cloudfrontPath}/programs/icons/program-detail/thumbsup_recommend.svg`}
        width={30}
        height={30}
        alt="おすすめの研修プログラムのアイコン"
      />
    </div>
    <div className="lg:ml-[0.6vw]">
      <h2 className="text-[4.3vw] lg:text-[1.4vw] font-bold text-[#333333]">
        {heading}
      </h2>
    </div>
  </div>
)
